export default "__VITE_ASSET__ed2bb38d__"